// Location Assignment routes
export default [
  {
    path: 'customer-sample-analyses',
    name: 'customer-sample-analyses',
    redirect: 'customer-sample-analyses/index',
    component: () =>
      import(
        /* webpackChunkName: "customerSampleAnalyses" */ '../views/customerSampleAnalyses/CustomerSampleAnalyses.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'customerSampleAnalysesIndex',
        meta: {
          tabbable: true,
          tableKeys: ['customerSampleAnalyses'],
          filterKeys: ['customerSampleAnalyses'],
          formKeys: [],
          routePermissions: ['sampleAnalysisLocationView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "customerSampleAnalysesIndex" */ '../views/customerSampleAnalyses/CustomerSampleAnalysesIndex.vue'
          ),
      },
    ],
  },
];
